import { useState } from 'react';
import { createSupportActions, getSupportActions, getSupportAdminActions } from '../../../redux/Help&Support/actions';
import { useDispatch, useSelector } from 'react-redux';
import { baymetal } from '../img/images';
import { Modal, Button } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

const HelpSupport = ({ show, hide, file }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const [attachment, setAttachment] = useState(null);
    const [description, setDescription] = useState('');
    const [issueType, setIssueType] = useState('');
    const [priorityType, setPriorityType] = useState('medium');
    const currentYear = new Date().getFullYear();
    const store = useSelector((state) => state);
    const user = store?.Auth?.user?.id;
    const Role = store?.Auth?.user?.role;

    const getCurrentPageInfo = () => {
        const currentPageURL = location.pathname;
        const currentPageName = currentPageURL
            .substring(currentPageURL.lastIndexOf('/') + 1)
            .replace(/-/g, ' ') // Replace hyphens with spaces
            .replace(/([a-z])([A-Z])/g, '$1 $2') // Add space between lowercase and uppercase letters
            .replace(/\b\w/g, (c) => c.toUpperCase());
        return { currentPageURL, currentPageName };
    };

    // Function to convert Data URL to Blob
    function dataURLtoBlob(dataURL) {
        if (!dataURL) {
            return null;
        }
        const parts = dataURL.split(',');
        const contentType = parts[0].split(':')[1].split(';')[0];
        const byteString = atob(parts[1]);
        const buffer = new ArrayBuffer(byteString.length);
        const uintArray = new Uint8Array(buffer);
        for (let i = 0; i < byteString.length; i++) {
            uintArray[i] = byteString.charCodeAt(i);
        }
        return new Blob([buffer], { type: contentType });
    }

    const onSubmitData = (e) => {
        e.preventDefault();

        // Ensure file is not undefined before converting to blob
        const image = file ? dataURLtoBlob(file) : null;

        // Create FormData object and append data
        const formData = new FormData();
        formData.append('image', attachment || image);
        formData.append('description', description);
        formData.append('moduleName', getCurrentPageInfo().currentPageName);
        formData.append('currentPageUrl', 'http://103.185.212.115:4001' + location.pathname);
        formData.append('issueType', issueType);
        formData.append('priority', priorityType);
        formData.append('userId', user);

        // Dispatch action to create support
        dispatch(createSupportActions(formData));
        if (Role === 'user') {
            dispatch(getSupportActions({ userId: user, status: 'pending' }));
        } else {
            dispatch(
                getSupportAdminActions({
                    status: '',
                    limit: 20,
                    pages: 0,
                })
            );
        }
        // Clear form fields and hide modal
        hide();
        setAttachment(null);
        setDescription('');
        setIssueType('');
    };

    const close = () => {
        hide();
        setAttachment(null);
        setDescription('');
        setIssueType('');
        if (Role === 'user') {
            dispatch(getSupportActions({ userId: user, status: 'pending' }));
        } else {
            dispatch(
                getSupportAdminActions({
                    status: '',
                    limit: 20,
                    pages: 0,
                })
            );
        }
    };

    const [show2, setShow2] = useState(false);
    const handleShow2 = () => setShow2(true);
    const handleClose2 = () => setShow2(false);

    const handleContentClick = (e) => {
        e.stopPropagation(); // Stop propagation to prevent modal from closing
    };

    return (
        <div onMouseDown={handleContentClick}>
            <Modal show={show} onHide={close} centered style={{ background: '#3b39399c' }} backdrop="static">
                <div className="modal-content">
                    <Modal.Header className="px-2 py-1 bg-info   text-white">
                        <Modal.Title className="col-8 text-end pe-3  m-0">
                            {' '}
                            <i className="bi bi-headset me-2"></i>Help & Support
                        </Modal.Title>
                        <div className="col-4 text-end">
                            <i className="mdi mdi-close fs-3" onClick={close} style={{ cursor: 'pointer' }}></i>
                        </div>
                    </Modal.Header>
                    <hr className="m-0" style={{ borderTop: '1px solid black' }} />
                    <Modal.Body className="py-1">
                        <form autoComplete="off" onSubmit={onSubmitData}>
                            <div className="row">
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-7">
                                            <div className="col-md-12 mt-2">
                                                <h4>
                                                    Name:
                                                    <span className="text-success fw-bold">
                                                        {getCurrentPageInfo().currentPageName}
                                                    </span>
                                                </h4>
                                            </div>
                                            <div className="col-md-12 mt-2">
                                                <div className="form-group d-flex">
                                                    <label className=" pe-2 fw-bold ">URL:</label>
                                                    <a href={location.pathname} title="view">
                                                        {location.pathname.slice(0, 42)}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-5">
                                            <img
                                                className="mt-2 ps-2"
                                                src={baymetal}
                                                alt="Bay Metal Group Logo"
                                                style={{ maxHeight: '40px' }}
                                            />
                                            {file ? (
                                                <></>
                                            ) : (
                                                <span
                                                    onClick={handleShow2}
                                                    className="fw-bold fs-4 text-info"
                                                    title="more info"
                                                    style={{
                                                        position: 'absolute',
                                                        cursor: 'pointer',
                                                        transform: 'translate(-8px, 50px)',
                                                    }}>
                                                    ⓘ
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2">
                                    {file ? (
                                        <div>
                                            <label htmlFor="image">Attachment</label>
                                            <img src={file} alt="" className="w-50 h-50 border ms-2 p-1 bg-secondary" />
                                        </div>
                                    ) : (
                                        <div className="form-group">
                                            <label htmlFor="image">Attachment</label>
                                            <input
                                                style={{ height: '34px' }}
                                                type="file"
                                                id="image"
                                                className="form-control"
                                                accept="image/*"
                                                // required
                                                onChange={(e) => setAttachment(e.target.files[0])}
                                            />
                                        </div>
                                    )}
                                </div>
                                <div className="col-md-12 mt-2">
                                    <div className="row">
                                        <div className="col-6">
                                            {' '}
                                            <div className="form-group">
                                                <label htmlFor="issueType">Issue Type</label>
                                                <select
                                                    style={{ height: '34px' }}
                                                    id="issueType"
                                                    className="form-control"
                                                    value={issueType}
                                                    required
                                                    onChange={(e) => setIssueType(e.target.value)}>
                                                    <option value="" hidden>
                                                        Select Issue Type
                                                    </option>
                                                    <option value="bug">Bug</option>
                                                    <option value="recomended">Recomendation</option>
                                                    <option value="enhancement">Enhancement</option>
                                                    <option value="other">Other</option>
                                                </select>
                                                {issueType === 'other' ? (
                                                    <span className="text-danger small">
                                                        Describe Below <i className="mdi mdi-arrow-down-bold"></i>
                                                    </span>
                                                ) : (
                                                    <></>
                                                )}
                                            </div>
                                        </div>
                                        <div className="col-6">
                                            <div className="form-group">
                                                <label htmlFor="priorityType">Priority</label>
                                                <select
                                                    style={{ height: '34px' }}
                                                    id="priorityType"
                                                    className="form-control"
                                                    value={priorityType}
                                                    required
                                                    onChange={(e) => setPriorityType(e.target.value)}>
                                                    <option value="" hidden>
                                                        Select Priority Type
                                                    </option>
                                                    <option value="critical">Critical</option>
                                                    <option value="high">High</option>
                                                    <option value="medium">Medium</option>
                                                    <option value="low">Low</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2">
                                    <div className="form-group">
                                        <label htmlFor="description">
                                            Tell us more about {issueType ? issueType : <>Issue</>}
                                        </label>
                                        <textarea
                                            id="description"
                                            className="form-control"
                                            rows="3"
                                            required
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}></textarea>
                                    </div>
                                </div>
                                <div className="col-md-12 mt-2 d-flex justify-content-between align-items-center">
                                    <span style={{ fontSize: '11px' }}>
                                        1969-{currentYear} Copyright © Bay Metal, Inc. All Rights Reserved.
                                    </span>
                                    <Button type="submit" className="btn btn-primary rounded-pill">
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </form>
                    </Modal.Body>
                </div>
            </Modal>

            {/* contact */}
            <Modal show={show2} onHide={handleClose2} size="md" centered style={{ background: 'rgb(44 44 44 / 79%)' }}>
                <Modal.Header className="px-2 py-1 bg-info   text-white">
                    <Modal.Title className="col-8 text-end pe-0 m-0">Contact Information</Modal.Title>
                    <div className="col-4 text-end">
                        <i className="mdi mdi-close fs-3" onClick={handleClose2} style={{ cursor: 'pointer' }}></i>
                    </div>
                </Modal.Header>
                <hr className="m-0" style={{ borderTop: '1px solid black' }} />
                <Modal.Body>
                    <div className="row">
                        <div className="col-6">
                            <address>
                                <strong>Bay Metal, INC.</strong>
                                <br />
                                National Headquarters
                                <br />
                                4100 Congress Parkway West
                                <br />
                                Richfield, Ohio 44286
                                <br />
                                <strong>Telephone:</strong> (330) 659.0900
                                <br />
                                <strong>ITran:</strong> 330-659-0900
                            </address>
                        </div>
                        <div className="col-6">
                            <a href="https://www.baymetal.com/" title="visit">
                                <img src={baymetal} alt="Bay Metal Group Logo" style={{ maxHeight: '50px' }} />
                            </a>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex border-top justify-content-between align-items-center py-0">
                    <div>
                        <a
                            href="https://www.facebook.com/pages/Bay-Metal/156776397696709"
                            target="_blank"
                            rel="noopener noreferrer">
                            <i className="mdi mdi-facebook me-2 fs-2 text-primary"></i>
                        </a>
                        <a
                            href="https://www.linkedin.com/company/bay-metal-inc"
                            target="_blank"
                            rel="noopener noreferrer">
                            <i className="mdi mdi-linkedin me-2 fs-2 text-info"></i>
                        </a>
                    </div>
                    <Button variant="secondary" className="rounded-pill" onClick={handleClose2}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default HelpSupport;
